/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../app/theme/components/baSidebar/baSidebar.component';
import * as i2 from '../baMenu/baMenu.component.ngfactory';
import * as i3 from '../../../../../app/theme/components/baMenu/baMenu.component';
import * as i4 from '@angular/router';
import * as i5 from '../../../../../app/theme/services/baMenu/baMenu.service';
import * as i6 from '../../../../../app/global.state';
const styles_BaSidebar:any[] = ([] as any[]);
export const RenderType_BaSidebar:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_BaSidebar,
    data:{}});
export function View_BaSidebar_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'aside',[['class',
      'al-sidebar'],['sidebarResize','']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i0.ɵeld(2,0,(null as any),(null as any),1,'ba-menu',([] as any[]),(null as any),
          [[(null as any),'expandMenu']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.BaSidebar = _v.component;
            if (('expandMenu' === en)) {
              const pd_0:any = ((<any>_co.menuExpand()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_BaMenu_0,i2.RenderType_BaMenu)),i0.ɵdid(3,245760,(null as any),
      0,i3.BaMenu,[i4.Router,i5.BaMenuService,i6.GlobalState],{sidebarCollapsed:[0,
          'sidebarCollapsed'],menuHeight:[1,'menuHeight']},{expandMenu:'expandMenu'}),
      (_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵted(-1,(null as any),['\n'])),
      (_l()(),i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i1.BaSidebar = _v.component;
    const currVal_0:any = _co.isMenuCollapsed;
    const currVal_1:any = _co.menuHeight;
    _ck(_v,3,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_BaSidebar_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-ba-sidebar',
      ([] as any[]),(null as any),[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).onWindowResize()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_BaSidebar_0,RenderType_BaSidebar)),i0.ɵdid(1,4308992,(null as any),0,
      i1.BaSidebar,[i0.ElementRef,i6.GlobalState],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const BaSidebarNgFactory:i0.ComponentFactory<i1.BaSidebar> = i0.ɵccf('app-ba-sidebar',
    i1.BaSidebar,View_BaSidebar_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvYmFTaWRlYmFyL2JhU2lkZWJhci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL3RoZW1lL2NvbXBvbmVudHMvYmFTaWRlYmFyL2JhU2lkZWJhci5jb21wb25lbnQudHMiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvdGhlbWUvY29tcG9uZW50cy9iYVNpZGViYXIvYmFTaWRlYmFyLmh0bWwiLCJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvdGhlbWUvY29tcG9uZW50cy9iYVNpZGViYXIvYmFTaWRlYmFyLmNvbXBvbmVudC50cy5CYVNpZGViYXJfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXNpZGUgY2xhc3M9XCJhbC1zaWRlYmFyXCIgc2lkZWJhclJlc2l6ZT5cclxuICA8YmEtbWVudSBbbWVudUhlaWdodF09XCJtZW51SGVpZ2h0XCJcclxuICAgICAgICAgICBbc2lkZWJhckNvbGxhcHNlZF09XCJpc01lbnVDb2xsYXBzZWRcIlxyXG4gICAgICAgICAgIChleHBhbmRNZW51KT1cIm1lbnVFeHBhbmQoKVwiIFxyXG4gICAgICAgICAgID48L2JhLW1lbnU+XHJcbjwvYXNpZGU+XHJcbjwhLS0gKG1vdXNlb3Zlcik9XCJtZW51RXhwYW5kKClcIiAobW91c2VvdXQpPVwibWVudUNvbGxhcHNlKClcIiAtLT5cclxuIiwiPGFwcC1iYS1zaWRlYmFyPjwvYXBwLWJhLXNpZGViYXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUEsOEJBQXdDLDRDQUN0QzthQUFBO1VBQUE7WUFBQTtZQUFBO1lBRVM7Y0FBQTtjQUFBO1lBQUE7WUFGVDtVQUFBLGlEQUFBO01BQUE7VUFBQTtNQUdvQiwwQ0FDZDtNQUN1RDs7SUFKcEQ7SUFEQTtJQUFULFdBQ1MsVUFEQSxTQUFUOzs7O29CQ0RGO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSxpREFBQTttQkFBQTs7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/theme/components/baSidebar/baSidebar.component.ngfactory.ts